import {
  fetchJson,
  COMPLETE_CHECKOUT,
  PLACE_ORDER_ASYNC
} from '../../GlobalStateContainer'

import {
  notifyCompleteCheckoutError,
  notifyDuplicatePOCheckoutError
} from '../UserMessaging'

/* COMPLETE CHECKOUT */

export function completeCheckout() {
  return {type: COMPLETE_CHECKOUT}
}

/* ASYNC ACTION CREATORS */
const onPlaceOrderSuccess = (responseObject, { placeOrderDetails }, getState) => {
    if (responseObject.Success) {
        // No return, because we're navigating away from the app
        if (typeof window !== 'undefined' && typeof window.location !== 'undefined') {
            window.location.href = getState().constants.navigation.orderConfirmationUrl +"?orderNumber=" + responseObject.order.OrderNumber;
        }
        return null;
    } else {
        if (responseObject.Message == 'Duplicate PO found. Please enter a new PO, and try again.') {
            return notifyDuplicatePOCheckoutError("We could not complete your checkout. " + responseObject.Message,
                JSON.stringify(responseObject));
        } else {
            return notifyCompleteCheckoutError("We could not complete your checkout. " + responseObject.Message,
                JSON.stringify(responseObject));
        }        
    }
}

const completeCheckoutAsyncSpec = {
    endpoint: (state) => state.constants.navigation.placeOrderEndpoint,
    fetchInit: { method: 'POST', credentials: 'same-origin' },
    notify: ( placeOrderDetails ) => ({ type: PLACE_ORDER_ASYNC, placeOrderDetails }),
    extract: (response) => response.json(),
    onSuccess: onPlaceOrderSuccess,
    onError: (diagMsg) => notifyCompleteCheckoutError("An error occurred placing your order", diagMsg)
}

export const completeCheckoutAsync = fetchJson(completeCheckoutAsyncSpec);




// WEBPACK FOOTER //
// ./src/Components/checkout/Features/PlaceOrder/placeOrderActionCreators.js